import { useInfiniteQuery } from "react-query";
import { axiosClient } from "@/services/utilities";

const fetchPublishers = async ({ pageParam = "" }) => {
  const res = await axiosClient.get(
    `/publishers/usernames?size=5${pageParam ? `&after_key=${pageParam}` : ""}`
  );

  const data = res.data;

  return {
    items: data.publishers.map((p: any) => p.username),
    nextKey: data.after_key ?? null
  };
};

export const useApiPublishers = () =>
  useInfiniteQuery(
    ["publishers"],
    fetchPublishers,
    {
      getNextPageParam: (lastPage) => lastPage.nextKey || undefined,
    }
  );
